import { ORG, SOCIAL_LINKS } from "./tsc";
const officialSocials = SOCIAL_LINKS.reduce((acc, social) => {
  acc[social.key] = social.url;
  return acc;
}, {});

const defaultAvatar = ORG.logo;

export const TSC_OFFICIAL = {
  id: "tsc",
  slug: "tsc",
  name: "TSC",
  role: "Official Org",
  games: ["Esports", "Content", "Community"],
  platform: "All Platforms",
  team: "The Shadow Corp",
  joined: "2025",
  twitch_login: "tsc_esports",
  avatar_url: "/avatars/tsc.png",
  live: false,
  bio: "The official channel hub for The Shadow Corp. Follow TSC for announcements, recruitment, content drops, streams, and community updates.",
  focus: "Official updates, recruitment, content, and community growth",
  socials: {
      discord: ORG.discordInvite,
      twitch: "https://www.twitch.tv/tsc_esports",
      tiktok: "https://www.tiktok.com/@theshadowcorp.gg?lang=en",
      youtube: "https://www.youtube.com/@TheShadowCorpgg",
      instagram: "https://www.instagram.com/theshadowcorp.gg/",
      x: "https://x.com/theshadowcorpgg",
    },
};
export const MEMBERS = [
  {
    id: "yoru",
    slug: "yoru",
    name: "Yoru",
    role: "Founder / Creator",
    games: ["Rocket League", "Game Development", "Content"],
    platform: "PC",
    team: "The Shadow Corp",
    joined: "2025",
    twitch_login: "itsyourtv",
    avatar_url: "/avatars/yoru.jpg",
    live: false,
    bio: "Founder of The Shadow Corp, building TSC into an esports, content, community, and game development collective.",
    focus: "Org leadership, content, recruitment, and long-term brand growth",
    socials: {
      discord: ORG.discordInvite,
      twitch: "https://www.twitch.tv/itsyorutv",
      tiktok: "https://www.tiktok.com/@itsyorutv?lang=en",
      youtube: "https://www.youtube.com/@itsyorutv",
      instagram: "https://www.instagram.com/itsrllydii/",
      x: "https://x.com/itsyorutv",
    },
  },
  {
    id: "mxko",
    slug: "mxko",
    name: "Mxko",
    role: "Player",
    games: ["Rocket League"],
    platform: "PC / Console",
    team: "The Shadow Corp",
    joined: "2025",
    twitch_login: "ttvmxko",
    avatar_url: "/avatars/mxko.jpg",
    live: false,
    bio: "Competitive player representing The Shadow Corp across ranked, scrims, and future tournament play.",
    focus: "Competitive growth, team chemistry, and highlight moments",
    socials: {},
  },
  {
    id: "youkno",
    slug: "youkno",
    name: "Youkno",
    role: "Player / Creator",
    games: ["Rocket League", "Content"],
    platform: "PC / Console",
    team: "The Shadow Corp",
    joined: "2025",
    twitch_login: "youkno_rl",
    avatar_url: "/avatars/youkno.jpg",
    live: false,
    bio: "A ranked grinder and creator presence inside TSC, helping build the competitive and content side of the movement.",
    focus: "Ranked gameplay, clips, and community presence",
    socials: {},
  },
  {
    id: "sero",
    slug: "sero",
    name: "Sero",
    role: "Player",
    games: ["Rocket League"],
    platform: "PC / Console",
    team: "The Shadow Corp",
    joined: "2025",
    twitch_login: "delus1onalm1nd",
    avatar_url: "/avatars/sero.png",
    live: false,
    bio: "A TSC player focused on improving, competing, and growing with the team as the organization expands.",
    focus: "Competitive development and team play",
    socials: {},
  },
];